import * as React from 'react';
import { IconProps } from '../types';

const IcPlus = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
     <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M12.5 4.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-1.5 0V5.25a.75.75 0 0 1 .75-.75Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M5 12a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 0 1.5H5.75A.75.75 0 0 1 5 12Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M12.5 4c-.69 0-1.25.56-1.25 1.25v5.5h-5.5a1.25 1.25 0 1 0 0 2.5h5.5v5.5a1.25 1.25 0 1 0 2.5 0v-5.5h5.5a1.25 1.25 0 1 0 0-2.5h-5.5v-5.5c0-.69-.56-1.25-1.25-1.25Zm.25 6.75v-5.5a.25.25 0 1 0-.5 0v5.5h.5Zm-.5 1h.5v.5h-.5v-.5Zm-1 0h-5.5a.25.25 0 1 0 0 .5h5.5v-.5Zm1 1.5v5.5a.25.25 0 1 0 .5 0v-5.5h-.5Zm1.5-1v-.5h5.5a.25.25 0 1 1 0 .5h-5.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcPlus;